export default __webpack_public_path__ + "static/new-header-57fc6dd31ae4dab4492d785eeb5d28a2.png";